const analyticsFilterReducer = (
    state = {},
    action: {
      type: "SET_ANALYTICS_FILTER_OBJECT";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_ANALYTICS_FILTER_OBJECT":
        return { ...state, ...action.payload };
  
      default:
        return state;
    }
  };
  
  export default analyticsFilterReducer;
  